"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetVoiceProfilesRequestToJSON = exports.GetVoiceProfilesRequestFromJSONTyped = exports.GetVoiceProfilesRequestFromJSON = exports.instanceOfGetVoiceProfilesRequest = void 0;
var runtime_1 = require("../runtime");
var ProviderType_1 = require("./ProviderType");
/**
 * Check if a given object implements the GetVoiceProfilesRequest interface.
 */
function instanceOfGetVoiceProfilesRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfGetVoiceProfilesRequest = instanceOfGetVoiceProfilesRequest;
function GetVoiceProfilesRequestFromJSON(json) {
    return GetVoiceProfilesRequestFromJSONTyped(json, false);
}
exports.GetVoiceProfilesRequestFromJSON = GetVoiceProfilesRequestFromJSON;
function GetVoiceProfilesRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : json['language'],
        'providerType': !(0, runtime_1.exists)(json, 'provider_type') ? undefined : (0, ProviderType_1.ProviderTypeFromJSON)(json['provider_type']),
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
    };
}
exports.GetVoiceProfilesRequestFromJSONTyped = GetVoiceProfilesRequestFromJSONTyped;
function GetVoiceProfilesRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'language': value.language,
        'provider_type': (0, ProviderType_1.ProviderTypeToJSON)(value.providerType),
        'id': value.id,
    };
}
exports.GetVoiceProfilesRequestToJSON = GetVoiceProfilesRequestToJSON;
